<template>
  <div class="CopyLinkAndTextModal copy-link-and-text pa-5">
    <h2 class="copy-link-and-text__title">{{ title }}</h2>

    <div class="d-flex mt-4">
      <BaseInput
        :value="link"
        readonly
        class="flex-grow-1"
      />
      <button
        class="base-btn  base-btn--green ml-3"
        @click.prevent="onCopyLink"
      >
        <BaseSvg name="ico-copy" width="1.2rem" height="1.2rem" />
        <span>{{ $tGlobal('copy_link') }}</span>

        <span class="small-tooltip" :class="{ _show: show.copyLinkTooltip }">
            <BaseSvg name="ico-check"/>
            <span>{{ $tGlobal('link_copied') }}</span>
          </span>
      </button>
    </div>

    <div
      v-if="htmlText"
      class="mt-5"
    >
      <div class="copy-link-and-text__html-title ml-1">
        {{ htmlTextTitle }}
      </div>

      <div v-html="htmlText" class="copy-link-and-text__html pa-3 mt-2"></div>

      <div class="mt-2">
        <button
          class="base-btn  base-btn--green flex-grow-1"
          @click.prevent="onCopyHtml"
        >
          <BaseSvg name="ico-copy" width="1.2rem" height="1.2rem" />
          <span>{{ $tGlobal('copy_text') }}</span>

          <span class="small-tooltip" :class="{ _show: show.copyHtmlTooltip }">
            <BaseSvg name="ico-check"/>
            <span>{{ $tGlobal('link_copied') }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
let timerCopy = null;

export default {
  name: 'CopyLinkAndTextModal',
  props: {
    title: String,
    link: String,
    htmlText: String,
    htmlTextTitle: String,
    textToCopy: String,
  },
  data() {
    return {
      show: {
        copyLinkTooltip: false,
        copyHtmlTooltip: false,
      },
    };
  },
  methods: {
    onCopyLink() {
      this.copy(this.link);
      this.show.copyLinkTooltip = true;

      clearTimeout(timerCopy);
      timerCopy = setTimeout(() => {
        this.show.copyLinkTooltip = false;
      }, 2000);
    },
    onCopyHtml() {
      this.copy();
      this.show.copyHtmlTooltip = true;

      clearTimeout(timerCopy);
      timerCopy = setTimeout(() => {
        this.show.copyHtmlTooltip = false;
      }, 2000);
    },
    copy(text = this.textToCopy) {
      navigator.clipboard.writeText(text);
    },
  },
};
</script>
